/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Blocks_Studio_SubtitleInputs */

const cs_builder_blocks_studio_subtitle = /** @type {(inputs: Builder_Blocks_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidávejte a přeuspořádejte bloky. Barvy motivu platí pro layout. Až budete hotovi, uložte.`)
};

const en_builder_blocks_studio_subtitle = /** @type {(inputs: Builder_Blocks_Studio_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add and rearrange blocks. Theme colors apply to the layout. Save when you are done.`)
};

/**
* | output |
* | --- |
* | "Add and rearrange blocks. Theme colors apply to the layout. Save when you are done." |
*
* @param {Builder_Blocks_Studio_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_blocks_studio_subtitle = /** @type {((inputs?: Builder_Blocks_Studio_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Blocks_Studio_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_blocks_studio_subtitle(inputs)
	return cs_builder_blocks_studio_subtitle(inputs)
});